"use client";
import { useState } from "react";
export function RevisionDate({ iso }: Readonly<{ iso: string }>) {
  const [now] = useState(Date.now);
  const date = new Date(iso);
  const seconds = Math.max(0, Math.floor((now - date.getTime()) / 1000));
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  let age: string;

  if (seconds < 120) age = "just now";
  else if (minutes < 60) age = `${minutes}m ago`;
  else if (hours < 24) age = `${hours}h ago`;
  else if (days < 7) age = `${days}d ago`;
  else {
    age = date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year:
        date.getFullYear() === new Date(now).getFullYear()
          ? undefined
          : "numeric",
    });
  }

  return (
    <time dateTime={iso} title={date.toLocaleString()}>
      {age}
    </time>
  );
}
